// Navbar.jsx
import React, { useState, useEffect } from 'react';

const Navbar = () => {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [dropdownItems, setDropdownItems] = useState({
    services: [],
    products: [],
    innovation: ['R&D Solutions', 'New Technologies', 'Product Development', 'Industry Research']
  });

  const createSlug = (text) => {
    return text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
  };

  const getNavigationUrl = (category, item) => {
    const slug = createSlug(item);
    if (category === 'products') return `/products/${slug}`;
    if (category === 'services') return `/services/${slug}`;
    if (category === 'innovation') return `/innovation/${slug}`;
    return '#';
  };

  useEffect(() => {
    const fetchNavData = async () => {
      try {
        const [servicesRes, productsRes] = await Promise.all([
          fetch(`${process.env.REACT_APP_API_URL}/api/services/`),
          fetch(`${process.env.REACT_APP_API_URL}/api/products/`)
        ]);
        const services = await servicesRes.json();
        const products = await productsRes.json();
        setDropdownItems(prev => ({
          ...prev,
          services: services.map(s => s.title),
          products: products.map(p => p.title)
        }));
      } catch (error) {
        console.error('Error fetching nav data:', error);
      }
    };
    fetchNavData();
  }, []);

  return (
    // hidden on small screens; center area uses flex-1 so it takes remaining space
    <nav className="hidden lg:flex flex-1 justify-center min-w-0">
      <ul className="flex flex-wrap items-center gap-6 justify-center min-w-0">
        <li><a href="/" className="font-heading transition-colors text-text-primary hover:text-red-500">Home</a></li>

        <li className="relative"
            onMouseEnter={() => setActiveDropdown('services')}
            onMouseLeave={() => setActiveDropdown(null)}
        >
          <a href="/services" className="flex items-center gap-1 font-heading transition-colors text-text-primary hover:text-red-500">
            Services <span className="text-xs">▼</span>
          </a>
          {activeDropdown === 'services' && (
            <div className="absolute left-0 w-56 p-4 bg-white rounded-lg shadow-lg top-full z-30">
              {dropdownItems.services.map((item, index) => (
                <a key={index} href={getNavigationUrl('services', item)} className="block py-2 text-slate-600 hover:text-red-500">{item}</a>
              ))}
            </div>
          )}
        </li>

        <li className="relative"
            onMouseEnter={() => setActiveDropdown('products')}
            onMouseLeave={() => setActiveDropdown(null)}
        >
          <a href="/products" className="flex items-center gap-1 font-heading transition-colors text-text-primary hover:text-red-500">
            Products <span className="text-xs">▼</span>
          </a>
          {activeDropdown === 'products' && (
            <div className="absolute left-0 w-56 p-4 bg-white rounded-lg shadow-lg top-full z-30">
              {dropdownItems.products.map((item, index) => (
                <a key={index} href={getNavigationUrl('products', item)} className="block py-2 text-slate-600 hover:text-red-500">{item}</a>
              ))}
            </div>
          )}
        </li>

        <li className="relative"
            onMouseEnter={() => setActiveDropdown('innovation')}
            onMouseLeave={() => setActiveDropdown(null)}
        >
          <a href="/innovation" className="flex items-center gap-1 font-heading transition-colors text-text-primary hover:text-red-500">
            Innovation <span className="text-xs">▼</span>
          </a>
          {activeDropdown === 'innovation' && (
            <div className="absolute left-0 w-56 p-4 bg-white rounded-lg shadow-lg top-full z-30">
              {dropdownItems.innovation.map((item, index) => (
                <a key={index} href={getNavigationUrl('innovation', item)} className="block py-2 text-slate-600 hover:text-red-500">{item}</a>
              ))}
            </div>
          )}
        </li>

        <li><a href="/blogs" className="font-heading transition-colors text-text-primary hover:text-red-500">Blogs</a></li>
        <li><a href="/about" className="font-heading transition-colors text-text-primary hover:text-red-500">About Us</a></li>
        <li><a href="/contact" className="font-heading transition-colors text-text-primary hover:text-red-500">Contact Us</a></li>
      </ul>
    </nav>
  );
};

export default Navbar;
